const CONFIG = {
  "metadata": {
    "version": "2026.05.20",
    "name": "Mental Health Survey",
    "description": "Mental health survey. This questionaire will be asked partially every house visit and completly evey lab session."
  },
  "sections": {
    "phq9": {
      "title": "PHQ-9",
      "infoText": "Over the last 2 weeks, how often have you been bothered by any of the following problems?",
      "sectionStart": "phq9_interest",
      "sectionEnd": "phq9_difficulty",
      "translation": {
        "gu": {
          "title": "PHQ-9",
          "infoText": "છેલ્લા ૨ અઠવાડિયામાં, તમે આમાંથી કોઈ પણ સમસ્યાથી કેટલી વાર પરેશાન રહ્યા છો?"
        },
        "hi": {
          "title": "PHQ-9",
          "infoText": "पिछले २ सप्ताहों में, आप इन समस्याओं मेंसे किसी से भी कितनी बार परे शान रहे है?"
        },
        "es": {
          "title": "PHQ-9",
          "infoText": "Durante las últimas 2 semanas, ¿qué tan seguido ha tenido molestias debido a los siguientes problemas?"
        }
      }
    },
    "gad7": {
      "title": "GAD-7",
      "infoText": "Over the last 2 weeks, how often have you been bothered by any of the following problems?",
      "sectionStart": "gad7_nervous",
      "sectionEnd": "gad7_difficulty",
      "translation": {
        "gu": {
          "title": "GAD-7",
          "infoText": "છેલ્લા ૨ અઠવાડિયામાં, તમે આમાંથી કોઈ પણ સમસ્યાથી કેટલી વાર પરેશાન રહ્યા છો?"
        },
        "hi": {
          "title": "GAD-7",
          "infoText": "पिछले २ सप्ताहों में, आप इन समस्याओं मेंसे किसी से भी कितनी बार परे शान रहे है?"
        },
        "es": {
          "title": "GAD-7",
          "infoText": "Durante las últimas 2 semanas, ¿qué tan seguido ha tenido molestias debido a los siguientes problemas?"
        }
      }
    }
  },
  "structure": [
    {
      "id": "phq9_interest",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Interest / Pleasure",
      "infoText": "Little interest or pleasure in doing things",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "રસ / આનંદ",
          "infoText": "શું તમને રોજિંદી પ્રવૃતિ (જેમ કે ભણવામાં, રમવામાં, ટીવી જોવામાં, વગેરે) કરવામાં રસ ઓછો થવા લાગ્યો છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "रुचि / आनंद",
          "infoText": "कोई कार्य करने में बहुत कम दिलचस्पी या मज़ा आना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Interés / Placer",
          "infoText": "Poco interés o placer en hacer cosas",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_depressed",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Mood",
      "infoText": "Feeling down, depressed, or hopeless",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "મનોદશા",
          "infoText": "શું તમને હતાશા, ચીડિયાપણું, નિરાશાજનક લાગણી જેવા ભાવ અનુભવાય છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "मनोदशा",
          "infoText": "उदास, दुःखी या निराश महसूस करना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Estado de ánimo",
          "infoText": "Se ha sentido decaído(a), deprimido(a) o sin esperanzas",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_sleep",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Sleep",
      "infoText": "Trouble falling or staying asleep, or sleeping too much",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ઊંઘ",
          "infoText": "શું તમને એકા-એક ઓછી ઊંઘ આવવી, વચ્ચેથી ઊંઘ ઊડી જાવી કે વધારે ઊંઘ આવવી જેવા અનુભવ થાય છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "नींद",
          "infoText": "नींद आने में या सोये रहने में परेशानी, या फिर बोहोत अधिक सोना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Sueño",
          "infoText": "Ha tenido dificultad para quedarse o permanecer dormido(a), o ha dormido demasiado",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_tired",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Energy",
      "infoText": "Feeling tired or having little energy",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ઊર્જા",
          "infoText": "શું તમને થાક લાગે છે અથવા અશક્તિ અનુભવાય છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "ऊर्जा",
          "infoText": "थकान महसूस करना या बहुत कम ऊर्जा होना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Energía",
          "infoText": "Se ha sentido cansado(a) o con poca energía",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_appetite",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Appetite",
      "infoText": "Poor appetite or overeating",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ભૂખ",
          "infoText": "શું તમને ઓછી/વધારે ભૂખ લાગવી, વજનમાં ઘટાડો/વધારો અનુભવાય છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "भूख",
          "infoText": "भूख कम लगना या ज़्यादा लगना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Apetito",
          "infoText": "Sin apetito o ha comido en exceso",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_self_worth",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Self-worth",
      "infoText": "Feeling bad about yourself — or that you are a failure or have let yourself or your family down",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "આત્મ-મૂલ્ય",
          "infoText": "શું તમારા વિશે ખરાબ લાગણી અનુભવો છો અથવા તમે તમારી જાતને નિષ્ફળ માનો છો?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "आत्म-सम्मान",
          "infoText": "अपने बारे में बुरा महसूस करना - ऐसा लगना की हमारे कारन सबको निचा महसूस करना पद रहा है",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Autoestima",
          "infoText": "Se ha sentido mal con usted mismo(a) – o que es un fracaso o que ha quedado mal con usted mismo(a) o con su familia",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_concentration",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Concentration",
      "infoText": "Trouble concentrating on things, such as reading the newspaper or watching television",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ધ્યાન",
          "infoText": "શું વસ્તુઓ અથવા દૈનિક પ્રવૃત્તિઓ પર ધ્યાન કેન્દ્રિત કરવામાં મુશ્કેલી પડે છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "ध्यान",
          "infoText": "अख़बार पढ़ने / किताब पढ़ने या टीवी देखने जैसी दैनिक चीज़ों पर ध्यान केंद्रित करने में मुश्किल होना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Concentración",
          "infoText": "Ha tenido dificultad para concentrarse en ciertas actividades, tales como leer el periódico o ver la televisión",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_psychomotor",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Psychomotor",
      "infoText": "Moving or speaking so slowly that other people could have noticed. Or the opposite — being so fidgety or restless that you have been moving around a lot more than usual",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ગતિ / વર્તન",
          "infoText": "શું તમારા બોલવાની ગતિમાં કે વર્તનમાં એકાએક કોઈ ફેર જણાય છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "गति / व्यवहार",
          "infoText": "इतना धीरे चलना, फिरना या बोलना की लोगों का ध्यान जाएँ? या इसका उल्टा- इतना अस्थिर या बेचैन होना की हम सामान्य से ज़्यादा हिलते डुलते रहे",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Movimiento",
          "infoText": "¿Se ha movido o hablado tan lento que otras personas podrían haberlo notado? o lo contrario – muy inquieto(a) o agitado(a) que ha estado moviéndose mucho más de lo normal",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_self_harm",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Self-harm",
      "infoText": "Thoughts that you would be better off dead, or of hurting yourself in some way",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "સ્વ-નુકસાન",
          "infoText": "શું તમને પોતાની જાતને કોઈ પણ નુકશાન પહોંચાડવાના વિચારો આવે છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "स्व-हानि",
          "infoText": "अपने आप को नुक्सान पहुंचने के विचार आना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Autolesión",
          "infoText": "Pensamientos de que estaría mejor muerto(a) o de lastimarse de alguna manera",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "phq9_difficulty",
      "section": "phq9",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Difficulty",
      "infoText": "If you said yes to any of the problems above, please tell us — have these problems made your daily work and routine difficult for you?",
      "options": [
        "Not difficult at all",
        "Somewhat difficult",
        "Very difficult",
        "Extremely difficult"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "મુશ્કેલી",
          "infoText": "તમારું રોજબરોજ નું કામ કરવું, ઘરની વસ્તુઓ તથા પોતાની કાળજી લેવી અને અન્ય લોકો સાથે હળીમળીને રહેવું. એમાં મુશ્કેલી લાગે છે?",
          "options": [
            "જરા પણ મુશ્કેલ નથી",
            "કંઈક અંશે મુશ્કેલ",
            "ઘણું અઘરું",
            "અત્યંત મુશ્કેલ"
          ]
        },
        "hi": {
          "title": "कठिनाई",
          "infoText": "अगर आपने ऊपर से किसी भी समस्या के लिए हां कहा हैं, तो बताएं इन समस्याओं ने आपके लिए आपका रोज़ का काम और दिनचर्या कठिन बनाया हैं?",
          "options": [
            "बिलकुल मुश्किल नहीं",
            "थोड़ा बोहोत मुश्किल",
            "बोहोत मुश्किल",
            "बेहद मुश्किल"
          ]
        },
        "es": {
          "title": "Dificultad",
          "infoText": "Si marcó cualquiera de los problemas, ¿qué tanta dificultad le han dado estos problemas para hacer su trabajo, encargarse de las tareas del hogar, o llevarse bien con otras personas?",
          "options": [
            "No ha sido difícil",
            "Un poco difícil",
            "Muy difícil",
            "Extremadamente difícil"
          ]
        }
      }
    },
    {
      "id": "gad7_nervous",
      "section": "gad7",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Nervousness",
      "infoText": "Feeling nervous, anxious, or on edge",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ગભરાટ",
          "infoText": "શું તમને ગભરાટ અથવા બેચેની લાગે છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "बेचैनी",
          "infoText": "बेचैनी, चिंता या तनाव महसूस करना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Nerviosismo",
          "infoText": "Sentirse nervioso, ansioso o nervioso",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "gad7_worry_control",
      "section": "gad7",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Worry control",
      "infoText": "Not being able to stop or control worrying",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ચિંતા નિયંત્રણ",
          "infoText": "શું તમને ચિંતાને રોકવા અથવા નિયંત્રિત કરવામાં તકલીફ થાય છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "चिंता नियंत्रण",
          "infoText": "चिंता रोकने या नियंत्रित करने में कठिनाई होना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Control de preocupación",
          "infoText": "No poder detenerse o controlar la preocupación",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "gad7_worry_excess",
      "section": "gad7",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Excess worry",
      "infoText": "Worrying too much about different things",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "વધુ પડતી ચિંતા",
          "infoText": "શું તમને અલગ અલગ વસ્તુ/પ્રવૃતિઓ વિશે ખૂબ ચિંતા થાય છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "अत्यधिक चिंता",
          "infoText": "छोटी छोटी बातों के लिए बोहोत ज़्यादा चिंता करना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Preocupación excesiva",
          "infoText": "Preocuparse demasiado por cosas diferentes",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "gad7_relax",
      "section": "gad7",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Relaxation",
      "infoText": "Trouble relaxing",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "આરામ",
          "infoText": "શું તમને આરામ કરવામાં મુશ્કેલી પડે છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "आराम",
          "infoText": "आराम / रिलैक्स करें में परेशानी",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Relajación",
          "infoText": "Dificultad para relajarse",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "gad7_restless",
      "section": "gad7",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Restlessness",
      "infoText": "Being so restless that it's hard to sit still",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "બેચેની",
          "infoText": "શું તમે એટલા બેચેન બની જાવ છો કે શાંત બેસવું મુશ્કેલ પડે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "बेचैनी",
          "infoText": "इतनी ज़्यादा बेचैनी की स्थिर बैठने में मुश्किल होना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Inquietud",
          "infoText": "Ser tan inquieto que es difícil quedarse quieto",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "gad7_irritable",
      "section": "gad7",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Irritability",
      "infoText": "Becoming easily annoyed or irritable",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ચીડિયાપણું",
          "infoText": "શું તમને નાની-નાની બાબતમાં હેરાનગતિ કે ચીડ ચઢે છે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "चिड़चिड़ाहट",
          "infoText": "किसी भी बात पर आसानी से चिढ जाना",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Irritabilidad",
          "infoText": "Molestarse o irritarse con facilidad",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "gad7_afraid",
      "section": "gad7",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Fear",
      "infoText": "Feeling afraid as if something awful might happen",
      "options": [
        "Not at all",
        "Several days",
        "More than half the days",
        "Nearly every day"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "ભય",
          "infoText": "શું તમને એવી બીક લાગે છે કે કંઈક ભયંકર થશે?",
          "options": [
            "બિલકુલ નહીં",
            "કેટલાક દિવસો",
            "અડધા દિવસથી વધુ",
            "દરરોજ"
          ]
        },
        "hi": {
          "title": "डर",
          "infoText": "डर महसूस होना की शायद कुछ बोहोत बुरा हो जाए",
          "options": [
            "बिल्कुल नहीं",
            "कुछ दिन",
            "आधे से अधिक दिन",
            "लगभग हर दिन"
          ]
        },
        "es": {
          "title": "Miedo",
          "infoText": "Sentir miedo, como si algo horrible pudiera suceder",
          "options": [
            "Ningún día",
            "Varios días",
            "Más de la mitad de los días",
            "Casi todos los días"
          ]
        }
      }
    },
    {
      "id": "gad7_difficulty",
      "section": "gad7",
      "type": "multiple_choice",
      "answer_type": "numeric",
      "min_value": 0,
      "max_value": 3,
      "title": "Difficulty",
      "infoText": "If you said yes to any of the problems above, please tell us — have these problems made your daily work and routine difficult for you?",
      "options": [
        "Not difficult at all",
        "Somewhat difficult",
        "Very difficult",
        "Extremely difficult"
      ],
      "include_na": true,
      "translation": {
        "gu": {
          "title": "મુશ્કેલી",
          "infoText": "તમારું રોજબરોજ નું કામ કરવું, ઘરની વસ્તુઓ તથા પોતાની કાળજી લેવી અને અન્ય લોકો સાથે હળીમળીને રહેવું. એમાં મુશ્કેલી લાગે છે?",
          "options": [
            "જરા પણ મુશ્કેલ નથી",
            "કંઈક અંશે મુશ્કેલ",
            "ઘણું અઘરું",
            "અત્યંત મુશ્કેલ"
          ]
        },
        "hi": {
          "title": "कठिनाई",
          "infoText": "अगर आपने ऊपर से किसी भी समस्या के लिए हां कहा हैं, तो बताएं इन समस्याओं ने आपके लिए आपका रोज़ का काम और दिनचर्या कठिन बनाया हैं?",
          "options": [
            "बिलकुल मुश्किल नहीं",
            "थोड़ा बोहोत मुश्किल",
            "बोहोत मुश्किल",
            "बेहद मुश्किल"
          ]
        },
        "es": {
          "title": "Dificultad",
          "infoText": "Si marcó cualquiera de los problemas, ¿qué tanta dificultad le han dado estos problemas para hacer su trabajo, encargarse de las tareas del hogar, o llevarse bien con otras personas?",
          "options": [
            "No ha sido difícil",
            "Un poco difícil",
            "Muy difícil",
            "Extremadamente difícil"
          ]
        }
      }
    }
  ]
} 
export default CONFIG